import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { abfSerializeQueryArgs, marketsBaseQuery } from "./util";

const LOOP_POSITIONS_TAG = "LoopPositions";

// Thin slice so `resetLoopApi` / tag-based invalidation from transaction paths stays wired.
// No endpoints live here — loop data composes from /loans/info on the portfolio page.
export const loopApi = createApi({
    reducerPath: "loopApi",
    tagTypes: [LOOP_POSITIONS_TAG],
    baseQuery: marketsBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    endpoints: () => ({})
});

export const useLoopApi = () => {
    const dispatch = useDispatch();

    return {
        resetLoopApi: () => dispatch(loopApi.util.invalidateTags([LOOP_POSITIONS_TAG]))
    };
};
